import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorTranslatorService {
  constructor(private translate: TranslateService) {}

  translateErrors(errors: Array<string>) {
    if (errors) {
      let result: string = '';
      for (let error of errors) {
        if (result === '') {
          result = this.translateError(error);
        } else {
          result = result + '\n' + this.translateError(error);
        }
      }
      return result;
    }
  }

  private translateError(errorObject) {
    if (errorObject.error == 'blank') {
      return this.translate.instant('shared.errorTranslator.blank');
    } else if (errorObject.error == 'invalid') {
      return this.translate.instant('shared.errorTranslator.invalid');
    } else if (errorObject.error == 'current') {
      return this.translate.instant('shared.errorTranslator.current');
    } else if (errorObject.error == 'too_short') {
      return (
        this.translate.instant('shared.errorTranslator.tooShortPre') +
        ' ' +
        errorObject.minimum +
        ' ' +
        this.translate.instant('shared.errorTranslator.tooShortPost')
      );
    } else if (errorObject.error == 'does_not_match') {
      return this.translate.instant('shared.errorTranslator.doesNotMatch');
    } else if (errorObject.error == 'taken') {
      return this.translate.instant('shared.errorTranslator.taken');
    } else {
      return errorObject.error;
    }
  }
}
